import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HistoryPanelHeaderWithLink = ({
  titleKey,
  navigationLinkClickHandler,
  navigationLinkKey,
  navigationDirection = 'right'
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    className: "m-bottom-4",
    align: "center",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleKey
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: navigationDirection === 'right' ? 'row' : 'row-reverse',
      justify: navigationDirection === 'right' ? 'end' : 'start',
      className: "m-bottom-1",
      children: [/*#__PURE__*/_jsx(UILink, {
        onClick: navigationLinkClickHandler,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: navigationLinkKey
        })
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: navigationDirection,
        size: 16,
        color: EERIE,
        className: "m-x-1",
        style: {
          marginTop: '1px'
        }
      })]
    })]
  });
};
export default HistoryPanelHeaderWithLink;